<script setup lang="ts">
import PdsButton from '@/components/pds/PdsButton.vue';
import PdsModal from '@/components/pds/PdsModal.vue';
import PdsToggle from '@/components/pds/PdsToggle.vue';
import {
  useDisplayPrefs,
  type DisplayPrefs,
} from '../composables/useDisplayPrefs';

defineEmits<{ close: [] }>();

const prefs = useDisplayPrefs();

const rows: { key: keyof DisplayPrefs; label: string; hint: string }[] = [
  {
    key: 'customerNote',
    label: 'Note du client',
    hint: 'La pastille CLIENT sur chaque ticket qui en a une',
  },
  {
    key: 'expanded',
    label: 'Contenu de la commande',
    hint: 'Les produits de chaque commande, sans l’ouvrir',
  },
  {
    key: 'itemCount',
    label: 'Nombre de produits',
    hint: 'Le nombre de produits, sous la date',
  },
  {
    key: 'amount',
    label: 'Montant de la commande',
    hint: 'Le total payé, sur le ticket plié',
  },
  {
    key: 'compact',
    label: 'Cartes compactes',
    hint: 'Plus de commandes visibles, moins de détail',
  },
];
</script>

<template>
  <PdsModal size="base" @close="$emit('close')">
    <template #title>Affichage des commandes</template>
    <template #subtitle>
      <span class="text-[12px] leading-[1.45]">
        Ce que montre un ticket sur le tableau · propre à chaque opérateur
      </span>
    </template>
    <ul class="bg-creux flex flex-col gap-3 p-5">
      <li
        v-for="row in rows"
        :key="row.key"
        class="bg-carte flex min-h-[72px] items-center gap-[14px] rounded-[16px] px-4"
      >
        <div class="min-w-0 flex-1">
          <p class="text-[14px] leading-[20px] font-semibold">
            {{ row.label }}
          </p>
          <p class="text-encre-douce text-[12px] leading-[17px]">
            {{ row.hint }}
          </p>
        </div>
        <PdsToggle v-model="prefs[row.key]" :label="row.label" />
      </li>
    </ul>
    <template #footer>
      <PdsButton
        variant="second"
        fit
        class="sm:ml-auto"
        @click="$emit('close')"
      >
        Fermer
      </PdsButton>
    </template>
  </PdsModal>
</template>
